import SetupBsjParamsSmsModal from './setup-bsj-params-sms-modal.vue'
export default SetupBsjParamsSmsModal
